export interface AttributeListConfigModel {
  pageSize: number;
}

export const DEFAULT_ATTRIBUTE_LIST_CONFIG: AttributeListConfigModel = {
  pageSize: 100,
};
